module.exports = __webpack_public_path__ + "img/whispers_of_wood-hero-2.c0d6c6a.webp";